import { useLazyExportDraftQuoteQuery } from "features/api/orderApi.ts";
import { useEffect, useState } from "react";
import { APIErrorResponse, isApiErrorResponse } from "features/api/utils/apiUtils.ts";
import { models } from "types/api/viewModels.ts";
import { getFileNameBasedOnCurrentDateTime } from "utils/file.ts";

const useExportDraftQuote = () => {
	const [exportData, setExportData] = useState<ExportData>({ blob: null, loading: false, error: null });
	const [trigger, { data: exportApiData, error: exportApiError }] = useLazyExportDraftQuoteQuery();
	const [draft, setDraft] = useState<models["DraftOrderViewModel"] | null>(null);

	const exportFile = (draft: models["DraftOrderViewModel"]) => {
		setDraft(draft);
		trigger({ draftId: draft.draftOrderId });
		setExportData((prev) => ({ ...prev, loading: true }));
	};

	useEffect(() => {
		if (exportApiData && "type" in exportApiData) {
			setExportData({ blob: exportApiData, loading: false, error: null });
		}

		if (exportApiError) {
			const error = isApiErrorResponse(exportApiError)
				? exportApiError
				: new Error("Failed to export draft quote");
			setExportData({ blob: null, loading: false, error: error });
		}
	}, [exportApiData, exportApiError]);

	const fileName = getFileNameBasedOnCurrentDateTime(`${draft?.draftOrderId}_${draft?.draftName}`);

	useEffect(() => {
		if (exportData.blob) {
			const url = globalThis.URL.createObjectURL(exportData.blob);
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", `${fileName}.xlsx`);
			document.body.appendChild(link);
			link.click();
			setExportData({ blob: null, loading: false, error: null });
		}
	}, [exportData.blob, fileName]);

	return { exportData, exportFile };
};

interface ExportData {
	blob: Blob | null;
	loading: boolean;
	error: Error | APIErrorResponse | null | undefined;
}

export default useExportDraftQuote;
